



































import Vue from 'vue';
import Personal from '@/components/PersonalInformation.vue';
import Longevity from '@/components/Longevity.vue';
import AttendInfo from '@/components/AttendInfo.vue';
import PrayFor from '@/components/PrayFor.vue';
import FormApi from '@/apis/FormApi';

export default Vue.extend({
  components: {
    Personal,
    Longevity,
    PrayFor,
    AttendInfo,
  },
  data() {
    return {
      checkMode: true,
    };
  },
  computed: {
    ceremonyForm() {
      return this.$store.state.form.ceremonyForm;
    },
  },
  methods: {
    saveForm() {
      FormApi.save().then(() => {
        this.$router.push('/saveOnly');
      });
    },
    async submitForm() {
      if (this.ceremonyForm.personalInformation.name !== ''
        && this.ceremonyForm.personalInformation.address !== ''
        && this.ceremonyForm.personalInformation.informMethod !== '') {
        if (this.ceremonyForm.personalInformation.telephone !== ''
          || this.ceremonyForm.personalInformation.phone !== '') {
          if (this.ceremonyForm.personalInformation.informMethod === 'letter') {
            if (this.ceremonyForm.personalInformation.postcode !== '') {
              // 成功區(目前只有檢查personalInformation)
              await FormApi.save(true).then(() => {
                this.$router.push('/successful');
              });
              FormApi.load();
            } else {
              this.$notify({
                type: 'error',
                title: '未完成',
                text: '當通知方式為郵寄時，請記得填寫郵遞區號',
              });
            }
          } else {
            // 成功區(目前只有檢查personalInformation)
            await FormApi.save(true).then(() => {
              this.$router.push('/successful');
            });
            FormApi.load();
          }
        } else {
          this.$notify({
            type: 'error',
            title: '未完成',
            text: '至少要填寫電話或是行動電話',
          });
        }
      } else {
        this.$notify({
          type: 'error',
          title: '未完成',
          text: '請填寫完整個人資料',
        });
      }
    },
  },
});
